import '../../assets/cssFiles/four_page.css';

import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import FourModuleTemplate from '../../components/FourModuleTemplate';
import HalModule from './modules/HalModule';
import CareerModule from './modules/CareerModule';
import EductionModule from './modules/EductionModule';
import OnlineModule from './modules/OnlineModule';
import GetCareerModule from './modules/GetCareerModule';

const menus=[
    {
        path: '/five',
        title: '选考在线平台'
    },
    {
        path: '/five/getcareer',
        title: '壹志愿平台'
    },
    {
        path: '/five/career',
        title: '智慧生涯系统'
    },
    {
        path: '/five/eduction',
        title: '升学教育活动'
    },
    {
        path: '/five/online',
        title: '书籍出版'
    },
]

export default  class FiveModulePage extends Component{

    render(){
        return(
            <FourModuleTemplate menus={menus}>
                <Route path="/five" exact component={HalModule}/>
                <Route path="/five/career" component={CareerModule}/>
                <Route path="/five/eduction" component={EductionModule}/>
                <Route path="/five/online" component={OnlineModule}/>
                <Route path="/five/getcareer" component={GetCareerModule}/>
            </FourModuleTemplate>
        )
    }
}